import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ServicesService } from 'src/services/services.service';

@Component({
  selector: 'app-app-card-design',
  templateUrl: './app-card-design.component.html',
  styleUrls: ['./app-card-design.component.scss'],
  standalone:false
})
export class AppCardDesignComponent {
  imagefileURL: any;
  imgType: any;
  event_id: any;
  selectedCard: any;
  Card_Image_Name: any;
  type: any;
  image1: any;
  image2: any;
  image3: any;
  image4: any;

  constructor(
    private service: ServicesService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.event_id = params['event_id'];
      this.Get_Card(this.event_id);
    });
  }

  previewpimage(files: any) {
    if (files.length === 0) {
      return;
    }
    this.spinner.show();
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.imgType = 'event_image';
      this.service.uploadimage(this.imagefileURL, this.imgType).subscribe((data: any) => {
        this.image1 = data['image_name'];
        this.service.setImage(this.image1);
        this.spinner.hide();
      });
    };
  }

  selectCard(card: any) {
    this.selectedCard = card;
  }

  Get_Card(event_id: any) {
    this.service.get_card(event_id).subscribe(
      (data: any) => {
        this.Card_Image_Name = data.data;
        this.selectedCard = this.Card_Image_Name[0].design_name,
          this.type = this.Card_Image_Name[0].type,
          this.image1 = this.Card_Image_Name[0].image1,
          this.image2 = this.Card_Image_Name[0].image2,
          this.image3 = this.Card_Image_Name[0].image3,
          this.image4 = this.Card_Image_Name[0].image4,
          this.service.setImage(this.Card_Image_Name[0].image1);
      }
    )
  }

  Update_Card() {
    const Card_Data = {
      event_id: this.event_id,
      design_name: this.selectedCard,
      type: this.type,
      image1: this.image1,
      image2: this.image2,
      image3: this.image3,
      image4: this.image4,
    }
    this.service.edit_icard(Card_Data).subscribe(
      () => {
        window.location.reload();
        this.toastr.success("Card Design Updated SuccessFully");

      }
    )
  }

}
